var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('v-btn',{attrs:{"loading":_vm.loading,"color":"amber lighten-4 black--text","elevation":"0","large":""},on:{"click":function($event){return _vm.$emit('next')}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('nextStep'))+" ")]}),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-arrow-right ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }